import { br_identify, br_isEnabled } from './Bloomreach.js';

const br_consentOptIn = async (email, doubleOptInActivate) => {
  if (!br_isEnabled() || !email) return;

  const doubleOptIn = window._THULEDATA.Bloomreach?.DoubleOptIn === true;
  const apiUrl =
    doubleOptIn && !doubleOptInActivate
      ? '/api/sitecore/bloomreach/consentdoubleoptinrequest'
      : '/api/sitecore/bloomreach/consentoptin';

  br_identify(email);
  
  const res = await fetch(apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, location: window.location.href }),
  });
  if (!res.ok) throw new Error(`Failed consent opt in (${res.status})`);
};

const br_setConsent = async (email, consentList) => {
  if (!br_isEnabled() || !email) return;

  br_identify(email);

  const doubleOptIn = window._THULEDATA.Bloomreach?.DoubleOptIn === true;
  const apiUrl = doubleOptIn
    ? '/api/sitecore/bloomreach/consentdoubleoptinrequest'
    : '/api/sitecore/bloomreach/setcustomerconsent';

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, consentList, location: window.location.href }),
  });

  if (!response.ok) {
    throw new Error(`Failed consent update: ${response.status}`);
  }
};

const br_getCustomerConsents = async (email) => {
  if (!email) return false;

  try {
    const response = await fetch('/api/sitecore/bloomreach/customerconsentsbyemail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      console.warn(`Failed to fetch customer consents by email: ${response.status}`);
      return false;
    }

    const consents = await response.json();
    
    if (!Array.isArray(consents)) {
      return false;
    }

    // Find the newsletter consent - check both Name and Id fields
    const newsletterConsent = consents.find(
      (consent) =>
        consent.Name === 'Newsletter' ||
        consent.Name === 'Newsletters' ||
        consent.Id === 'Newsletter'
    );

    return newsletterConsent?.HasConsent === true;
  } catch (error) {
    console.error('Error checking newsletter consent by email:', error);
    return false;
  }
};

export { br_consentOptIn, br_setConsent, br_getCustomerConsents };
